import React from "react"
import { graphql } from "gatsby"

import { Meta } from "@shared"
import { CONSTANTS } from "@data"
import { logTool } from "@jsUtils"

import {
  Footer,
  Header,
  HeroGrid,
  GetInTouch,
  BoardOfDirectors,
  OurPeopleFeature,
  AdvisoryBoard
} from "@components/sections"

import Styles from "@pageStyles/ourpeople.module.scss"

const { PAGE_NAMES, THEMES, COLORS, PAGE_TRACKER_KEYS, PAGE_TRACKER_VALUES } = CONSTANTS

const log = logTool()

/**
 * Our People Page
 * @param {object} props - react props
 * @todo hook up meta data
 */
const OurPeoplePage = props => {
  const { data } = props
  const { contentfulOurPeople, contentfulPageMeta, contentfulCrmEventBasedModal } = data
  const { boardOfDirectors, advisoryBoard, team } = contentfulOurPeople
  const { isModalEnabledOnSite } = contentfulCrmEventBasedModal
  log("Our People Content:", { contentfulOurPeople, contentfulPageMeta })

  return (
    <>
      <Meta
        base={contentfulPageMeta}
        page={contentfulOurPeople}
        hubSpotObj={{
          contentTypeKey: PAGE_TRACKER_KEYS.LEADERSHIP_PEOPLE,
          contentTypeValue: PAGE_TRACKER_VALUES.WEBSITE_PAGE
        }}
      />

      <Header theme={THEMES.TIN} pageColor={COLORS.DARK} />
      <HeroGrid
        shortHeroSection
        theme={THEMES.TIN}
        color={COLORS.FLURO}
        page={PAGE_NAMES.OUR_PEOPLE}
        content={contentfulOurPeople}
        classes={{
          extraHeroWrapperRow: Styles.peopleHeroRow,
          extraHeroSection: Styles.peopleHeroSection,
          extraPageHeadingContent: Styles.peoplePageHeadingContent
        }}
      />
      <OurPeopleFeature theme={THEMES.LIGHT} color={COLORS.FLURO} data={team} />
      <BoardOfDirectors theme={THEMES.TIN} color={COLORS.FLURO} data={boardOfDirectors} />
      <AdvisoryBoard theme={THEMES.TIN} color={COLORS.FLURO} data={advisoryBoard} />

      <GetInTouch theme={THEMES.DARK} color={COLORS.FLURO} />
      {/* {isModalEnabledOnSite ? (
        <EmailModal data={contentfulCrmEventBasedModal} theme={THEMES.DARK} color={COLORS.FLURO} />
      ) : null} */}
      <Footer />
    </>
  )
}

/**
 * pageQuery for Our People Page
 * @todo is there a way to make the global data a fragment?
 */
export const pageQuery = graphql`
  {
    contentfulPageMeta(id: { eq: "423babd8-0278-5b2e-85f6-77fb7ee55bee" }) {
      ...GlobalMetaData
    }
    contentfulCrmEventBasedModal {
      heroImage {
        title
        fluid(quality: 100, maxWidth: 1920) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      supportingText
      heroText
      isModalEnabledOnSite
    }
    contentfulOurPeople {
      pageMeta {
        ...PageMetaData
      }
      title
      subhead
      headline {
        headline
      }
      boardOfDirectors {
        ...BoardOfDirectorsSection
      }
      advisoryBoard {
        ...AdvisoryBoardSection
      }
      team {
        ...OurPeopleFeatureSection
      }
    }
  }
`

export default OurPeoplePage
